import { Product } from './product';

export class ProductRelated {
    id = 0;
    product_id = 0;
    related_id = 0;

    related = new Product();
}
